import React from 'react';
import { motion } from 'framer-motion';
import { CreditCard, BarChart3, Code, Palette } from 'lucide-react';
import { GlassCard } from './ui/GlassCard';
const features = [{
  title: 'Recurring Billing',
  description: 'Automatyczne fakturowanie i obsługa płatności cyklicznych bez błędów.',
  icon: CreditCard,
  delay: 0
}, {
  title: 'Analytics Dashboard',
  description: 'Głęboki wgląd w metryki MRR, churn i LTV w czasie rzeczywistym.',
  icon: BarChart3,
  delay: 0.1
}, {
  title: 'API Integrations',
  description: 'Pełna dokumentacja API i gotowe biblioteki dla Twoich deweloperów.',
  icon: Code,
  delay: 0.2
}, {
  title: 'White-label Portal',
  description: 'Dostosuj portal klienta do swojej marki i kolorystyki.',
  icon: Palette,
  delay: 0.3
}];
export function FeaturesSection() {
  return <section className="relative z-10 py-24 px-4" data-id="element-23">
      <div className="max-w-7xl mx-auto" data-id="element-24">
        <div className="text-center mb-16" data-id="element-25">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold mb-4" data-id="element-26">
            Wszystko czego potrzebujesz
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-slate-400 max-w-2xl mx-auto text-lg" data-id="element-27">
            Platforma zaprojektowana, aby skalować Twój biznes subskrypcyjny od
            pierwszego klienta do IPO.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-28">
          {features.map((feature, index) => <GlassCard key={feature.title} hoverEffect={true} className="p-6 h-full flex flex-col" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: feature.delay,
          duration: 0.5
        }} data-id="element-29">
              <div className="w-12 h-12 rounded-xl bg-emerald-500/10 flex items-center justify-center text-emerald-400 mb-6 group-hover:bg-emerald-500/20 transition-colors" data-id="element-30">
                <feature.icon className="w-6 h-6" data-id="element-31" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-32">
                {feature.title}
              </h3>
              <p className="text-slate-400 leading-relaxed text-sm" data-id="element-33">
                {feature.description}
              </p>
            </GlassCard>)}
        </div>
      </div>
    </section>;
}